import { internal, template } from '../../../vendor/elix.js';
import eventPath from '../../../edge-browser-support/event-path.js';

function SelectionBaseMixin(Base) {

  return class SelectionBase extends Base {

    get label() {
      return this[internal.state].label;
    }

    set label(arg) {
      this[internal.setState]({ label: arg });
    }

    get [internal.template]() {
      return template.html`
      <div class="wrapper">
        <div id="selectionBox" class="selectionBox inputStateContainer">
          ${super[internal.template].innerHTML}
          <label id="label">
            <span id="labelText"></span> 
            <slot name="trailing"></slot>
          </label>
        </div>
      </div>
      <style>
        :host {
          cursor: pointer;
          display: inline-block;
          user-select: none;
        }
        
        .wrapper { height: 100%; }
        .selectionBox {
          align-items: center;
          box-shadow: inset 0 0 0 var(--tp-selection-box-border-size) var(--tp-selection-box-radio-color-border);
          border-radius: var(--tp-selection-box-border-radius);
          box-sizing: border-box;
          display: flex;
          padding-left: 8px;
          transition: .15s ease border-width, border-color;
          width: auto;
          height: 100%;
        }
        
        :host([helpertext]) .selectionBox {
            height: calc(100% - 19px);
        }
        
        .selectionBox.checked,
        :host(:hover) .selectionBox {
          background: var(--tp-checkable-color-selected--light);
          box-shadow: inset 0 0 0 var(--tp-selection-box-border-size--selected) var(--tp-checkable-color-selected);
        }
        
        #label {
          align-items: center;
          cursor: pointer;
          display: flex;
          font-size: var(--tp-selection-box-font-size);
          line-height: var(--tp-selection-box-line-height);
          justify-content: space-between;
          margin-left: 5px;
          padding: 14.5px 21px 14.5px 0;
          word-break: break-word;
          width: 100%;
        }
        
        .helpertext {
          margin-left: 16px;
          margin-top: 4px;
        }

        slot[name=trailing]::slotted(*) {
          margin-left: 8px;
        }
</style>
    `;
    }

    [internal.render](changed) {
      super[internal.render](changed);
      if (changed.label) {
        this.renderLabel();
      }
      if (changed.checked) {
        this.renderSelectedState();
      }
    }

    renderLabel() {
      const label = this[internal.ids].label;
      const labelText = this[internal.ids].labelText;
      if (label) {
        label.for = `${this.name}_${this.value}`;
        labelText.textContent = this.label;
      }
    }

    renderSelectedState() {
      const component = this[internal.ids].selectionBox;
      this.checked ? component.classList.add('checked') : component.classList.remove('checked');
    }

    [internal.componentDidMount]() {
      if (super[internal.componentDidMount]) {
        super[internal.componentDidMount]();
      }
      this.addEventListener('click', (e) => this.onLabelClick.call(this, e));
    }

    onLabelClick(e) {
      if (eventPath(e)[0].id === 'inner') {
        return;
      }
      this[internal.ids].inner.dispatchEvent(new Event('change'));
    }
  }
}

export default SelectionBaseMixin;
